import React from 'react';

const tagConfig = {
  'Pending Follow-up': { bg: 'bg-orange-100', text: 'text-orange-700', icon: '📅' },
  'Overdue Follow-up': { bg: 'bg-red-100', text: 'text-red-700', icon: '⚠️' },
  'WhatsApp Lead': { bg: 'bg-green-100', text: 'text-green-700', icon: '💬' },
  default: { bg: 'bg-gray-100', text: 'text-gray-700', icon: '🏷️' },
};

const TagBadge = ({ tag }) => {
  const config = tagConfig[tag] || tagConfig.default;
  
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-xs font-medium ${config.bg} ${config.text}`}>
      <span className="text-[10px]">{config.icon}</span>
      {tag}
    </span>
  );
};

export default TagBadge;